import React from 'react';

import clsx from 'clsx';

import { TableRow } from './TableRow';
import { getWarning } from './utils';

export interface TableHeadProps {
  children?: JSX.Element | JSX.Element[];
  className?: string;
  'data-testid'?: string;
}

export const TableHead: React.FC<TableHeadProps> = ({
  children,
  className,
  'data-testid': dataTestId,
}) => {
  return (
    <thead className={clsx(className, 'group')} data-testid={dataTestId}>
      {React.Children.map(children, (child) => {
        if (child?.type !== TableRow) {
          const warning = getWarning('TableHead', 'TableRow');
          console.error(warning);
        }
        return child;
      })}
    </thead>
  );
};
